import React, { Component } from "react";
import ModalBody from "react-bootstrap/ModalBody";
import { Button, Col, Row } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import RequestOrderProgress, { ConnectedRequestOrderDetails as RequestOrderDetails } from "../../external/request/request-details/order-request-details.component";
import RequestOwnerDetails from "../../external/request/request-details/request-owner-details.component";
import { APPROVAL_MESSAGE, REQUEST_TYPES_ID as RequestType, REQUEST_SUB_LINKS as RequestTable } from '../../../constants/external-constants';

import RequestOnBehalf from "../../external/request/request-form/request-on-behalf.component";
import EmailOptOut from "../../external/request/request-form/email-opt-out.component";
import { NoSubscription } from "../../external/dashboard/no-subscription/no-subscription.component";

//Wireless
import NewMobileSubscription from "../../external/request/request-form/wireless/new-mobile-subscription/new-mobile-subscription.component";
import MobileChangePricePlanForm from "../../external/request/request-form/wireless/wireless-change-price-plan.component";
import MobileChangeUserForm from "../../external/request/request-form/wireless/wireless-change-user.component";
import MobileChangeVendorForm from "../../external/request/request-form/wireless/change-vendor/wireless-change-vendor.component";
import MobileReplaceSimForm from "../../external/request/request-form/wireless/wireless-replace-sim.component";
import ReplaceDeviceForm from "../../external/request/request-form/wireless/wireless-replace-device.component";
import MobileTerminateSubscriptionForm from "../../external/request/request-form/wireless/wireless-terminate-subscription.component";
import MobilePortOutForm from "../../external/request/request-form/wireless/wireless-portout.component";
import MobileOtherForm from "../../external/request/request-form/wireless/wireless-other.component";
import PortInSubscription from "../../external/request/request-form/wireless/port-in-subscription/port-in-subscription.component";
import AccessoryForm from "../../external/request/request-form/wireless/wireless-accessory.component";
import IntlRoamingAccessForm from "../../external/request/request-form/wireless/intl-raoming-access.component";

//Wireline
import WirelineChangeVendorForm from "../../external/request/request-form/wireline/wireline-change-vendor.component";
import WirelineUpgradeCircuitForm from "../../external/request/request-form/wireline/upgrade-circuit/wireline-upgrade-circuit.component";
import WirelineTerminateForm from "../../external/request/request-form/wireline/terminate-circuit/wireline-terminate-form.component";
import WirelineOtherForm from "../../external/request/request-form/wireline/wireline-other.component";
import NewQuotationForm from "../../external/request/request-form/wireline/new-quotation/wireline-quotation-form.component";
import NewCircuitForm from "../../external/request/request-form/wireline/new-circuit/new-circuit-display-form.component";

import CSATModal from "../modal-popover/csat-modal.component";
import { csatActions } from "../../../store/external/csat-survey-reducer/csat-survey.reducer";
import { ORDER_STATUS } from "../../../constants/external-constants";

import Translation from "../../common/translation/translation.component";
import ButtonIcon from "../../button";
import { CONFIRMATION_VALUE } from "../../../utils/constant.utils";
import { requestDetailsActions } from "../../../store/external/request-reducer/request-details.reducer"
import { requestLogActions } from "../../../store/external/request-reducer/request-log.reducer";
import WirelineUpdatePlanForm from "../../external/request/request-form/wireline/update-plan/wireline-update-plan.component";

import { navMenuActions } from '../../../store/external/nav-menu-reducer/nav-menu.reducer'


export class ModalTextBody extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { messageBody } = this.props;
        return (
            <ModalBody>
                <div className='message-body'>{messageBody}</div>
            </ModalBody>
        );
    }
}

export class ModalRejectBody extends Component {

    render() {
        const { messageBody, rejectReason, onChangeAction } = this.props;
        return (
            <ModalBody>
                <div>
                    {messageBody}

                </div>
                <Form.Group>
                    <Form.Control
                        value={rejectReason}
                        as="textarea"
                        rows={5}
                        maxLength={255}
                        onChange={onChangeAction}
                    />
                </Form.Group>
            </ModalBody>
        );
    }
}

class ModalBodyOrderRequestDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showConModal: false,
            type: ""
        }
    }

    handleApprovalModal(type) {
        this.setState(prev => ({
            showConModal: !prev.showConModal,
            type: type
        }))
    }

    shouldDisplayCSATButton = (orderStatusId, IsOwner) => {
        var shouldDisplay = true;
        if (orderStatusId !== ORDER_STATUS.completed || !IsOwner)
            shouldDisplay = false;

        return shouldDisplay;
    }

    handleConfirmationModal = async (buttonType) => {
        if (buttonType === CONFIRMATION_VALUE.Ok) {
            this.setState(prev => ({
                showConModal: !prev.showConModal
            }));
            if (this.state.type === APPROVAL_MESSAGE.APPROVE) {
                const { handleCancelSubmission, item
                    , fetchRequestLogItems
                    , fetchRequestProgress, fetchOrderComments, fetchRequestDetails, handleApproveSubmission, fetchNewNavItems
                } = this.props;
                var isSuccess = await handleApproveSubmission();
                if (isSuccess) {
                    fetchRequestDetails();
                    fetchRequestProgress(false);
                    fetchOrderComments();
                    fetchRequestLogItems(0, RequestTable.approvalRequest.id);
                    fetchNewNavItems();
                }
            }
            if (this.state.type === APPROVAL_MESSAGE.REJECT) {
                const { handleCancelSubmission, item
                    , fetchRequestLogItems
                    , fetchRequestProgress, fetchOrderComments, fetchRequestDetails, handleRejectSubmission
                    , fetchNewNavItems
                } = this.props;
                var isSuccess = await handleRejectSubmission();
                if (isSuccess) {
                    fetchRequestDetails();
                    fetchRequestProgress(false);
                    fetchOrderComments();
                    fetchRequestLogItems(0, RequestTable.approvalRequest.id);
                    fetchNewNavItems();
                }
            }
        } else {
            this.setState({
                showConModal: false
            });
        }
    }

    render() {
        const { canCancelOrder, status, data, milestone, showConfirmationModal, activities, comments, isOtherRequest, isQuotationRequest, approverData, isApproverLoaded, csatSurveyRequest, handleShowSurvey, selectedItem, canHandleRequest
        } = this.props;
        const { IsOwner, IsRequestor } = this.props.requestDetail.selectedItem;
        const { showCSATButton } = this.props.csatSurveyRequest;

        return (
            <div>
                {csatSurveyRequest.isShow ? <CSATModal /> : ''}
                <ModalBody>
                    <Row>
                        <Col xs={3}>
                            <RequestOwnerDetails data={approverData} isLoading={isApproverLoaded} typeId={data?.Order?.RequestType?.RequestTypeID} />
                        </Col>
                        <Col>
                            <RequestOrderDetails data={data} status={status} isOtherRequest={isOtherRequest} isQuotationRequest={isQuotationRequest} selectedItem={selectedItem} />
                        </Col>
                        <Col>
                            <div className="order-progress-container">
                                <div className="order-progress">
                                    <RequestOrderProgress handleConfirmationModal={this.handleConfirmationModal} approvalType={this.state.type} showConModal={this.state.showConModal} milestone={milestone} activities={activities} comments={comments} history={this.props.history} />

                                </div>

                                {milestone[3]?.IsCompleted && IsOwner ?
                                    <div>
                                        <Button
                                            className="btn-secondary"
                                            variant="outline-secondary"
                                            onClick={(e) => handleShowSurvey(e)}
                                        >
                                            {showCSATButton ? <Translation translationKey="provide_feedback_button" /> : <Translation translationKey="see_feeback_button" />}
                                        </Button>
                                    </div>
                                    : (
                                        <div className="secondary-modal-container">
                                            {canCancelOrder &&
                                                <Button className="btn-secondary" variant="outline-secondary" onClick={showConfirmationModal}>
                                                    <Translation translationKey="cancel_request_button" />
                                                </Button>
                                            }
                                            {canHandleRequest &&
                                                <div className="modal-btn-icon-container">
                                                    <ButtonIcon iconLeft="duotune-xmark" iconSize="20px" onClick={() => this.handleApprovalModal(APPROVAL_MESSAGE.REJECT)} customClassName="btn-custom-secondary" labelName={<Translation translationKey="reject_button" />} isDisable={false} />
                                                    <ButtonIcon iconLeft="duotune-checkmark" iconSize="20px" onClick={() => this.handleApprovalModal(APPROVAL_MESSAGE.APPROVE)} isDisable={false} customClassName="btn-custom-secondary" labelName={<Translation translationKey="approve_button" />} />
                                                </div>}
                                        </div>
                                    )
                                }

                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </div>
        );
    }
}

const orderRequestMapStateToProps = (state) => {
    const { requestDetail, csatSurveyRequest, navMenu } = state;
    return {
        requestDetail,
        csatSurveyRequest,
        navMenu
    };
}

export default connect(
    orderRequestMapStateToProps,
    dispatch => bindActionCreators(Object.assign({}, csatActions, requestDetailsActions, requestLogActions, navMenuActions), dispatch)
)(ModalBodyOrderRequestDetail);

export class NewRequestModalBody extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disableROBCheckbox: false
        }
    }

    disableROBCheckbox = (v) => {
        this.setState({
            disableROBCheckbox: v
        });
    }

    renderForm = (typeId) => {

        var IsEnabledWirelineTab = JSON.parse(sessionStorage.getItem('IsEnabledWirelineTab'));
        var IsEnabledWirelessTab = JSON.parse(sessionStorage.getItem('IsEnabledWirelessTab'));


        let form;

        if (IsEnabledWirelessTab) {
            switch (typeId) {
                //Wireless Request
                case RequestType.simAndDevice:
                case RequestType.newMobileDevice:
                case RequestType.wifiDongleAndDataCard:
                case RequestType.simAndDeviceBSA:
                case RequestType.simOnlyBSA:
                case RequestType.multiSIMBSA:
                case RequestType.wifiDongleAndDataCardBIN:
                case RequestType.voiceSIMBIN:
                case RequestType.wifiDongleDataCardAndVoiceSIMBIN:
                case RequestType.newMobile:
                    form = <NewMobileSubscription disableAutoScroll={this.props.disableAutoScroll} hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                case RequestType.changePricePlan:
                    form = <MobileChangePricePlanForm modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.changeUser:
                    form = <MobileChangeUserForm hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.changeVendor:
                    form = <MobileChangeVendorForm hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                case RequestType.deviceReplacement:
                    form = <ReplaceDeviceForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.simReplacement:
                    form = <MobileReplaceSimForm modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.subscriptionCancellation:
                    form = <MobileTerminateSubscriptionForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} closeAction={this.props.closeAction} />
                    break;
                case RequestType.portOut:
                    form = <MobilePortOutForm modalMessage={this.props.modalMessage} hideRequestModal={this.props.hideRequestModal} modalClose={this.props.modalClose} />
                    break;
                case RequestType.otherRequestOther:
                case RequestType.other:
                case RequestType.changeNumber:
                case RequestType.enableHotspot:
                case RequestType.suspendResumeService:
                case RequestType.pukCode:
                case RequestType.otherSIMReplacement:
                case RequestType.otherChangeOfPlan:
                case RequestType.simActivation:
                    form = <MobileOtherForm hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.portIn:
                    form = <PortInSubscription disableAutoScroll={this.props.disableAutoScroll} hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                case RequestType.accessory:
                    form = <AccessoryForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                case RequestType.CallingAccess:
                case RequestType.intlRoamingAccess:
                    form = <IntlRoamingAccessForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
            }
            return (form);

        }

        if (IsEnabledWirelineTab) {
            switch (typeId) {
                //Wireline Request
                case RequestType.wirelineChangeVendor:
                    form = <WirelineChangeVendorForm countryName={this.props.data.Location.CountryName} hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.terminateSubscriptionWireline:
                    form = <WirelineTerminateForm modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} />
                    break;
                case RequestType.updatePlanWireline:
                    form = <WirelineUpdatePlanForm hideRequestModal={this.props.hideRequestModal} closeAction={this.props.closeAction} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.otherWireline:
                case RequestType.wirelineOtherOther:
                case RequestType.wirelineUpgradeCircuit:
                case RequestType.wirelineChangeLocationAddress:
                    form = <WirelineOtherForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} />
                    break;
                case RequestType.newQuotation:
                    form = <NewQuotationForm disableAutoScroll={this.props.disableAutoScroll} hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                case RequestType.newSubscriptionWireline:
                    form = <NewCircuitForm hideRequestModal={this.props.hideRequestModal} modalMessage={this.props.modalMessage} modalClose={this.props.modalClose} disableROBCheckbox={this.disableROBCheckbox} />
                    break;
                default:
            }

            return (form);
        };

     }

    render() {
        const { typeId, isLoaded, resetRequestDetails } = this.props;
        const { disableROBCheckbox } = this.state;
        return (
            <ModalBody>
                <ToastContainer />
                {
                    isLoaded ?
                        <Row>
                            <Col xs={4}>
                                <RequestOwnerDetails data={this.props.data} typeId={typeId} />
                            </Col>
                            <Col className="second-col-container" xs={7}>
                                <p>
                                    <Translation translationKey="mandatory_field_notice" /> (<span className="mandatory_symbol" >*</span>) <Translation translationKey="mandatory_field_notice_nxtLine" />
                                </p>
                                <RequestOnBehalf typeId={typeId} disableROBCheckbox={disableROBCheckbox} withIcon />
                                {this.renderForm(typeId)}
                            </Col>
                        </Row> :
                        <NoSubscription customClass="loading-page" title="Loading, Please Wait…" />
                }
            </ModalBody>
        );
    }

}
